export function decodeTeacherExperience(experience: string): [string, string] {
  return experience.split("|||") as [string, string];
}

export function encodeGenericAOE(profession: string, aoe: string) {
  return `${profession}|||${aoe}`;
}

export function decodeGenericAOE(v: string) {
  return v.split("|||") as [string, string];
}

export function encodeGenericSpec(profession: string, spec: string) {
  return `${profession}|||${spec}`;
}

export function decodeAOEExp(v: string) {
  return v.split("|||") as [string, string];
}

export function encodeProfAoeSpec(prof: string, aoe = "", spec = "") {
  return `${prof}|||${aoe}|||${spec}`;
}

export function decodeProfAoeSpec(v: string) {
  return v.split("|||") as [string, string, string];
}
